import { useLayoutEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';

function LazyTabPanel({ activeTab, tabId, children }) {
  const [entered, setEntered] = useState(false);

  useLayoutEffect(() => {
    if (activeTab === tabId) {
      setEntered(true);
    }
  }, [activeTab, tabId]);

  return entered ? (
    <Tab.Pane eventKey={tabId} className="h-100">
      {children}
    </Tab.Pane>
  ) : null;
}

export default LazyTabPanel;
